import { CTA, Text, TextAlignment } from '@volkswagen-onehub/components-core';
import { Add, ChevronUp } from '@volkswagen-onehub/icons-core';
import React from 'react';
import styled from 'styled-components';
import { getFinanciacionType } from '../../helpers/ofertas-helper';
import { Oferta } from '../../services/ofertas-service/models/ofertas';
import { useTrackingManager } from '../../tracking/use-tracking-manager';

const CTAShadow = styled.div`
	border-radius: 10000px;
	width: fit-content;
	display: contents;

	/* Shadow01 */
	box-shadow:
		0px 1px 2px 0px rgba(0, 14, 38, 0.2),
		0px 2px 8px 0px rgba(0, 14, 38, 0.1),
		0px 4px 5px 0px rgba(0, 14, 38, 0.12);
`;

export const OpenLayerCTA = ({
	buttonSize,
	setIsLayerVisible,
	setSelectedOferta,
	selectedOferta,
}: {
	buttonSize: 'small' | 'large';
	isLayerVisible: boolean;
	setIsLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	setSelectedOferta?: React.Dispatch<React.SetStateAction<Oferta>>;
	selectedOferta?: Oferta;
}): React.ReactElement => {
	const trackingManager = useTrackingManager();

	const handleOpenLayerOnClick = () => {
		if (setSelectedOferta && selectedOferta) {
			setSelectedOferta(selectedOferta);

			trackingManager.trackOfertasButtonClick(
				'Open Oferta Layer',
				{ contentId: 'Open Oferta Layer' },
				{
					CarlineId: selectedOferta.carline?.code.toString(),
					CarlineName: selectedOferta.carline?.title,
					ModelId: selectedOferta.motorizacionCode?.split('-')[0],
					ModelName: selectedOferta.carline?.salesgroup.model.name,
					ModelYear: selectedOferta.carline?.salesgroup.year.toString(),
					SalesgroupName: selectedOferta.carline?.salesgroup.title,
					PriceRateType: getFinanciacionType(selectedOferta),
					PriceRateTotal: selectedOferta?.cuota ?? undefined,
					PriceRateCurrency: 'EUR',
					PriceTotalTotal: selectedOferta?.precio ?? undefined,
					PriceTotalCurrency: 'EUR',
				},
			);
		}

		setIsLayerVisible(true);
	};

	return (
		<CTA
			tag="button"
			emphasis="primary"
			onClick={handleOpenLayerOnClick}
			ariaLabel="Abrir oferta layer"
			size={buttonSize}
			icon={<Add variant="default" ariaHidden />}
		/>
	);
};

export const OfertaCardAccordionCta = ({
	selectedOferta,
	currentOferta,
	setSelectedOferta,
	isLayerVisible,
	setIsLayerVisible,
}: {
	selectedOferta: Oferta;
	currentOferta: Oferta;
	setSelectedOferta: React.Dispatch<React.SetStateAction<Oferta>>;
	isLayerVisible: boolean;
	setIsLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
}): React.ReactElement => {
	const trackingManager = useTrackingManager();

	const handleSelectOfertaOnClick = (oferta: Oferta) => {
		setSelectedOferta(oferta);

		trackingManager.trackOfertasButtonClick(
			'Show Oferta Info',
			{ contentId: 'Show Oferta Info' },
			{
				CarlineId: oferta.carline?.code.toString(),
				CarlineName: oferta.carline?.title,
				ModelId: oferta.motorizacionCode?.split('-')[0],
				ModelName: oferta.carline?.salesgroup.model.name,
				ModelYear: oferta.carline?.salesgroup.year.toString(),
				SalesgroupName: oferta.carline?.salesgroup.title,
				PriceRateType: getFinanciacionType(oferta),
				PriceRateTotal: oferta?.cuota ?? undefined,
				PriceRateCurrency: 'EUR',
				PriceTotalTotal: oferta?.precio ?? undefined,
				PriceTotalCurrency: 'EUR',
			},
		);
	};

	return (
		<>
			{selectedOferta.id === currentOferta.id ? (
				<Text textAlign={TextAlignment.end}>
					<CTAShadow className="cta-shadow-open-layer">
						<OpenLayerCTA
							buttonSize="large"
							setIsLayerVisible={setIsLayerVisible}
							isLayerVisible={isLayerVisible}
							setSelectedOferta={setSelectedOferta}
							selectedOferta={selectedOferta}
						/>
					</CTAShadow>
				</Text>
			) : (
				<Text textAlign={TextAlignment.end}>
					<CTAShadow className="cta-shadow-open-info">
						<CTA
							tag="button"
							size="large"
							emphasis="primary"
							ariaLabel="Desplegar información"
							onClick={() => handleSelectOfertaOnClick(currentOferta)}
							icon={<ChevronUp variant="default" />}
						/>
					</CTAShadow>
				</Text>
			)}
		</>
	);
};
